/**
 * 区分 salesPhaseType（activities.sales_phase_type）
 * 出典：要件書 5.2（日本語は 02 D-089）。274：旧PCRM の商談フェーズ（deal_phase）の 6 値に戻した（10/13 ユーザー判断）。
 * 旧の値との対応：approach／meeting_schedule→meetingSchedule／meeting_done→meetingDone／proposal／contract→won／lost
 * 並びは旧 ActivityDetail・ActivityFormModal と同じ（案件ステータスと同じ並び）
 */
export const SALES_PHASE_TYPE_VALUES = [
  'approach',
  'meetingSchedule',
  'meetingDone',
  'proposal',
  'won',
  'lost',
] as const;

export type SalesPhaseType = (typeof SALES_PHASE_TYPE_VALUES)[number];

export const SALES_PHASE_TYPE_LABELS: Readonly<Record<SalesPhaseType, string>> = {
  approach: 'アプローチ',
  meetingSchedule: '打ち合わせ調整',
  meetingDone: '打ち合わせ実施',
  proposal: '提案',
  won: '成約',
  lost: '失注',
};

/** 旧の商談フェーズの札の色（旧 ActivityDetail の getPhaseConfig：地 bg・字 color） */
export const SALES_PHASE_TYPE_COLORS: Readonly<Record<SalesPhaseType, { color: string; bg: string }>> = {
  approach: { color: '#17a2b8', bg: '#d1ecf1' },
  meetingSchedule: { color: '#6c757d', bg: '#e9ecef' },
  meetingDone: { color: '#007bff', bg: '#cce5ff' },
  proposal: { color: '#856404', bg: '#fff3cd' },
  won: { color: '#28a745', bg: '#d4edda' },
  lost: { color: '#dc3545', bg: '#f8d7da' },
};

/**
 * 274 以前の新CRM の値 → 旧の値（既存データの付け替え・274-a1-sales-phase.ts で使う）。
 * 商談→打ち合わせ実施（移行元が打ち合わせ調整だったものは付け替えスクリプトが旧データを見て打ち合わせ調整にする）、交渉→提案、リード→アプローチ
 */
export const LEGACY_SALES_PHASE_TYPE_REMAP: Readonly<Record<string, SalesPhaseType>> = {
  lead: 'approach',
  meeting: 'meetingDone',
  negotiation: 'proposal',
};
